import { LegalPageMarkdown } from '../components/LegalPageMarkdown'

/**
 * Terms of Service — rendered from /docs/TERMS-OF-SERVICE.md
 *
 * Single source of truth: docs/TERMS-OF-SERVICE.md
 * This component loads and renders the markdown at runtime.
 */
export function TermsPage() {
  return (
    <LegalPageMarkdown
      filename="TERMS-OF-SERVICE"
      title="Termos de Serviço"
      otherLink={{ href: '/privacidade', label: 'Política de Privacidade' }}
    />
  )
}
